import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Box, VBox } from "@ui/box/Box";
import { CreditCard, Gauge, Info as InfoIcon, Settings as SettingsIcon, Store, Users } from "lucide-react";
import Button from "@ui/button/Button";
import { Error } from "@ui/error/Error";
import { Page } from "@ui/page/Page";
import Spacer from "@ui/spacer/Spacer";
import { Spinner } from "@ui/spinner/Spinner";
import { TabItem, Tabs } from "@ui/tabs/Tabs";
import { Typo } from "@ui/text/Typo";
import { GD } from "src/GD";
import { useRouter } from "src/services/Router";

import { checkFeature, TAvailableFeatures } from "src/Featuresmap";
import { Clients } from "../conponents/list/Clients";
import { MerchantsList } from "../conponents/list/MerchantsList";
import { FormParser } from "../FormParser";
import { Sessions } from "../forms/Sessions";
import { Settings } from "../forms/Settings";

//todo! @deprecated
export const AcquirerPage = () => {
	useLocale();
	//const params = useParams(); // id
	const router = useRouter();
	const acquirerID = router.currentParams.aid;

	const [acquirerResponse, , , busy] = GD.REQ_ACQUIRER.useRequest(null, {
		acquirerID: parseInt(acquirerID),
	});
	const acquirer = acquirerResponse?.data ?? null;
	const [project] = GD.REQ_CURRENT_PROJECT.useRequest();

	const label = project && project?.name + ": Acquirer " + (acquirer?.name ?? "");

	return (
		<Page
			label={label ?? undefined}
			// rightSection={<RightSectionClients />}
			sectionRightContent={
				<Button
					disabled={!acquirer}
					variant="primarySmall"
					onClick={function (): void {
						GD.S_ACQUIRER_EDITOR.invoke({
							acquirerID: acquirer?.id ?? 0,
						});
					}}>{msg("editAcquirer")}</Button>
			}>
			{busy && <Spinner />}
			<Error error={acquirerResponse?.error} />
			{acquirer && (
				<VBox sx={{ height: "100%", overflow: "auto" }}>
					<Tabs variant="modern" checkFeature={feature => checkFeature(feature as TAvailableFeatures)}>
						<TabItem title={msg("overview")} icon={<Gauge size={16} />}>
							<Overview acquirer={acquirer} />
						</TabItem>

						<TabItem title={msg("clients")} icon={<Users size={16} />}>
							<Spacer size="20px" />
							<Clients acquirerId={acquirer.id} />
						</TabItem>

						<TabItem title={msg("merchants")} icon={<Store size={16} />}>
							<Spacer size="20px" />
							<MerchantsList acquirer_id={acquirer.id} />
						</TabItem>

						<TabItem title={msg("payments")} icon={<CreditCard size={16} />}>
							<Spacer size="20px" />
							<Sessions target_id={acquirer.id} target_type="acquirer" />
						</TabItem>

						<TabItem title={msg("settings")} icon={<SettingsIcon size={16} />}>
							<Spacer size="20px" />
							<Settings target_id={acquirer.id} target_type="acquirer" />
						</TabItem>

						<TabItem title={msg("info_170322a3")} icon={<InfoIcon size={16} />}>
							<Spacer size="20px" />
							<FormParser
								key="info"
								onSubmit={data => {
									return GD.REQ_API.request({
										method: "settings/set",
										data: data,
									});
								}}
								onRequest={() =>
									GD.REQ_API.request({
										method: "settings/get",
										data: {
											target_id: acquirer.id,
											target_type: "acquirer",
											type: "acquirer_info",
										},
									})
								}
							/>
						</TabItem>
					</Tabs>
				</VBox>
			)}
		</Page>
	);
};

const Overview = ({ acquirer }: { acquirer: IAcquirer }) => {
	useLocale();
	return (
		<Box>
			<Spacer size="20px" />
			<Typo variant={"headMedium"} weight="600" color="textSecondary" block>{msg("info_170322a3")}</Typo>
			<Spacer size="30px" />
			<Box
				sx={{
					display: "grid",
					gap: "20px",
					gridTemplateColumns: "auto 1fr",
				}}>
				<Typo>{msg("name")}</Typo>
				<Typo>{acquirer.name}</Typo>

				<Typo>{msg("status_073c1634")}</Typo>
				<Typo>{acquirer.status}</Typo>
			</Box>
		</Box>
	);
};
